import { Component } from '@angular/core';
import { Validation } from '@app/core/resources/validation';
import { GlobalStateService } from '@app/core/services/global-state.service';
import { ValidationsService } from '@app/core/services/validations.service';
import { Router } from '@angular/router';
import { DocumentCollection } from 'ngx-jsonapi';
import { filter } from 'rxjs';

@Component({
    selector: 'app-alert-validation',
    templateUrl: './alert-validation.component.html',
    styleUrls: ['./alert-validation.component.scss']
})
export class AlertValidationComponent {
    public userDontHaveValidation: boolean = false;

    public validationTypeId: string = '';
    public constructor(
        private validationsService: ValidationsService,
        private globalStateService: GlobalStateService,
        public router: Router
    ) {
        this.getValidations();
    }

    private getValidations(): void {
        this.validationsService
            .all({ sort: ['-id'], beforepath: 'users/' + this.globalStateService.userId ?? '' })
            .pipe(filter((validations: DocumentCollection<Validation>): boolean => validations.source !== 'new'))
            .subscribe((validations: DocumentCollection<Validation>) => {
                this.extractFirstValidationByStatusAndRedirect(validations.data);
            });
    }

    private extractFirstValidationByStatusAndRedirect(validations: Array<Validation>): void {
        validations.forEach((validation: Validation): void => {
            if (validation.attributes.status === 'requested') {
                this.validationTypeId = validation.attributes.validation_type_id;
                this.userDontHaveValidation = true;
            }
        });
    }

    public goToValidation(): void {
        this.router.navigate(['/my/dashboard/validations/' + this.validationTypeId]);
    }
}
